import { render, staticRenderFns } from "./UploadNoteModal.vue?vue&type=template&id=24654ee8"
import script from "./UploadNoteModal.vue?vue&type=script&lang=js"
export * from "./UploadNoteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports